<template>
    <div>
        <period-banner></period-banner>

        <tryout-content />

        <v-row
            align="stretch"
            :dense="$vuetify.breakpoint.xs"
        >
            <v-col
                :cols="cols.default"
                :sm="cols.sm"
                :md="cols.md"
                :lg="cols.lg"
            >
                <next-and-recent-tryout></next-and-recent-tryout>
            </v-col>

            <v-col
                v-if="kelonGroupId"
                :cols="cols.default"
                :sm="cols.sm"
                :md="cols.md"
                :lg="cols.lg"
            >
                <kelon-video></kelon-video>
            </v-col>

            <v-col
                :cols="cols.default"
                :sm="cols.sm"
                :md="cols.md"
                :lg="cols.lg"
                v-if="
                    $vuetify.breakpoint.xs &&
                    $store.get('enrollment/selected@id') != 44
                "
            >
                <v-card @click="$vuetify.goTo('#estimation')">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <v-card-title>Estimasi Pendalaman</v-card-title>
                        </div>

                        <div>
                            <v-icon
                                class="mr-4"
                                x-large
                            >
                                mdi-brain
                            </v-icon>
                        </div>
                    </div>
                </v-card>
            </v-col>

            <v-col
                :cols="cols.default"
                :sm="cols.sm"
                :md="cols.md"
                :lg="cols.lg"
            >
                <v-skeleton-loader
                    v-if="summary === null"
                    type="image"
                    max-height="150"
                ></v-skeleton-loader>

                <v-card
                    v-else
                    :to="{ name: 'tryout' }"
                    class="fill-height"
                >
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <v-card-title>Tryout</v-card-title>
                            <v-card-subtitle>
                                Sudah / belum dikerjakan
                            </v-card-subtitle>
                        </div>

                        <div>
                            <v-icon
                                class="mr-4"
                                x-large
                            >
                                mdi-lightbulb-outline
                            </v-icon>
                        </div>
                    </div>

                    <v-card-text class="display-1 py-md-0">
                        {{ summary.tryout_done }} / {{ summary.tryout_total }}
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col
                :cols="cols.default"
                :sm="cols.sm"
                :md="cols.md"
                :lg="cols.lg"
            >
                <v-skeleton-loader
                    v-if="summary === null"
                    type="image"
                    max-height="150"
                ></v-skeleton-loader>

                <v-card
                    v-else
                    :to="{ name: 'grade' }"
                    class="fill-height"
                >
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <v-card-title>Nilai</v-card-title>
                            <v-card-subtitle>Rata-rata tryout</v-card-subtitle>
                        </div>

                        <div>
                            <v-icon
                                class="mr-4"
                                x-large
                            >
                                mdi-chart-line-variant
                            </v-icon>
                        </div>
                    </div>

                    <v-card-text class="display-1 py-md-0">
                        <template v-if="summary.average_grade">
                            {{ summary.average_grade }}
                        </template>

                        <template v-else>N/A</template>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <field-recommendation
            v-if="$store.get('enrollment/selected@id') != 44"
            class="mt-8"
            id="estimation"
        ></field-recommendation>
    </div>
</template>

<script>
import NextAndRecentTryout from './NextAndRecentTryout'
import FieldRecommendation from './components/FieldRecommendation'
import PeriodBanner from './components/PeriodBanner.vue'
import KelonVideo from './KelonVideo.vue'
import TryoutContent from './TryoutContent.vue'

export default {
    components: {
        TryoutContent,
        NextAndRecentTryout,
        FieldRecommendation,
        PeriodBanner,
        KelonVideo,
    },

    data() {
        return {
            summary: null,
        }
    },

    computed: {
        kelonGroupId() {
            return this.$store.get('enrollment/selected@kelon_group_id')
        },

        cols() {
            return this.kelonGroupId
                ? {
                      default: '12',
                      sm: '6',
                      md: '6',
                      lg: '3',
                  }
                : {
                      default: '12',
                      sm: '4',
                      md: '4',
                      lg: '4',
                  }
        },
    },

    created() {
        this.$api.get('history/summary').then((response) => {
            this.summary = response.data
        })
    },
}
</script>
